import React from 'react';
import { StyleSheet, View } from 'react-native';
import { scale } from '../../Styles';

import { history } from '../../util/History';
import { StudentRecordProps } from '../containers/StudentRecordContainer';
import { MNOHSAcademicGrid } from '../MNOHSAcademicGrid';
import { MNOHSCourseGrid } from '../MNOHSCourseGrid';
import { MNOHSCourseLegends } from '../MNOHSCourseLegends';
import { MNOHSDashboardWrapper } from '../MNOHSDashboardWrapper';
import { MNOHSFloatingIndicator } from '../MNOHSFloatingIndicator';
import { MNOHSRecordHeader } from '../MNOHSRecordHeader';
import { MNOHSRecordStats } from '../MNOHSRecordStats';

export const StudentRecordScreen: React.FC<StudentRecordProps> = ({
  student,
  courseGroups,
  isGettingCourseGroups,
  isGettingStudent,
  userPressedCourseDetails,
}) => {
  return (
    <MNOHSDashboardWrapper headerTitle={'Student Record'} padded={true}>
      {Boolean(isGettingStudent) && <MNOHSFloatingIndicator />}

      <MNOHSRecordHeader student={student} onBackPress={() => history.push('/overall-student-list')} />
      <MNOHSRecordStats student={student} />

      <View style={styles.studentDetails}>
        {Boolean(isGettingCourseGroups) ? (
          <MNOHSFloatingIndicator style={{ position: undefined }} padded={true} />
        ) : (
          <MNOHSAcademicGrid courseGroups={courseGroups} />
        )}
        <MNOHSCourseLegends />
      </View>

      <MNOHSCourseGrid userPressedCourseDetails={userPressedCourseDetails} />
    </MNOHSDashboardWrapper>
  );
};

const styles = StyleSheet.create({
  studentDetails: {
    backgroundColor: '#fff',
    marginVertical: scale(8),
    marginHorizontal: scale(-20),
    padding: scale(16),
  },
});
